export const projects = {
  // Hero Section
  heroTitle: 'Student Projects',
  heroSubtitle: 'Students changing the world with cosmic thinking',
  badge1: '100+ Completed Projects',
  badge2: 'Real Problem Solving',
  badge3: 'International Awards',

  // Category Filter
  categoryAll: 'All',
  categoryEarthScience: 'Earth Science',
  categoryMoon: 'Moon',
  categoryRovers: 'Rovers',
  categoryMars: 'Mars',
  categorySpaceLife: 'Space Life',
  categoryStars: 'Stars',
  categoryAI: 'AI',

  // Project 1
  project1Title: 'Earth Climate System',
  project1Students: '3 students, Grade 4',
  project1Description: 'Week 1 project: Created interactive model showing Earth\'s climate patterns',
  project1Achievement: 'Class Presentation Award',
  project1Tag1: 'Climate',
  project1Tag2: 'Data Visualization',
  project1Tag3: 'Presentation',

  // Project 2
  project2Title: 'Lunar Base Design',
  project2Students: '4 students, Grade 5',
  project2Description: 'Week 2 project: Designed and built 3D model of lunar habitat',
  project2Achievement: 'Best Design Award',
  project2Tag1: 'Design',
  project2Tag2: '3D Modeling',
  project2Tag3: 'Teamwork',

  // Project 3
  project3Title: 'Mars Exploration Rover',
  project3Students: '2 students, Grade 4',
  project3Description: 'Week 3 project: Built working rover with sensors and programmed movement',
  project3Achievement: 'Innovation Prize',
  project3Tag1: 'Robotics',
  project3Tag2: 'Programming',
  project3Tag3: 'Engineering',

  // Project 4
  project4Title: 'Mars Survival Plan',
  project4Students: '3 students, Grade 5',
  project4Description: 'Week 4 project: Created comprehensive Mars mission survival strategy',
  project4Achievement: 'Problem-Solving Excellence',
  project4Tag1: 'Problem Solving',
  project4Tag2: 'Research',
  project4Tag3: 'Planning',

  // Project 5
  project5Title: 'Space Station Food System',
  project5Students: '3 students, Grade 4',
  project5Description: 'Week 5 project: Designed sustainable food production for space',
  project5Achievement: 'Creativity Award',
  project5Tag1: 'Biology',
  project5Tag2: 'Sustainability',
  project5Tag3: 'Design',

  // Project 6
  project6Title: 'Constellation Map',
  project6Students: '2 students, Grade 5',
  project6Description: 'Week 6 project: Created detailed constellation map with mythology',
  project6Achievement: 'Artistic Excellence',
  project6Tag1: 'Astronomy',
  project6Tag2: 'Art',
  project6Tag3: 'Storytelling',

  // Project 7
  project7Title: 'AI Data Analyzer',
  project7Students: '3 students, Grade 4',
  project7Description: 'Week 7 project: Built simple AI to analyze space data patterns',
  project7Achievement: 'Tech Innovation Award',
  project7Tag1: 'AI',
  project7Tag2: 'Data Science',
  project7Tag3: 'Coding',

  // Project 8
  project8Title: 'Complete Space Mission',
  project8Students: '4 students, Grade 5',
  project8Description: 'Week 8 final project: Comprehensive Mars exploration mission plan',
  project8Achievement: 'Final Project Excellence',
  project8Tag1: 'Comprehensive',
  project8Tag2: 'Planning',
  project8Tag3: 'Presentation',

  // Testimonials Section
  testimonialsTitle: 'Student',
  testimonialsTitleHighlight: 'Testimonials',
  testimonialsSubtitle: 'Stories from students who completed projects',

  testimonial1Name: 'Seojun Kim',
  testimonial1Grade: 'Elementary School Grade 5',
  testimonial1Project: 'Mars Exploration Rover',
  testimonial1Quote: 'I built a rover at EDUSPACE! It was difficult at first, but my teacher and friends helped me finish it. I felt like a real space scientist!',

  testimonial2Name: 'Jiwoo Park',
  testimonial2Grade: 'Elementary School Grade 4',
  testimonial2Project: 'Earth Climate Research',
  testimonial2Quote: 'While studying Earth\'s climate, I learned how important it is to protect the environment. The weekly presentation time was the most fun!',

  testimonial3Name: 'Haeun Lee',
  testimonial3Grade: 'Elementary School Grade 5',
  testimonial3Project: 'AI Data Analysis',
  testimonial3Quote: 'Analyzing space data with AI was fascinating. I learned so much in 8 weeks and want to learn more!',

  // CTA Section
  ctaTitle: 'Start Your',
  ctaTitleHighlight: 'Project',
  ctaSubtitle: 'Join the journey of changing the world with cosmic thinking',
  ctaButton1: 'Start Project',
  ctaButton2: 'View Curriculum'
};
